import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deDE } from '@mui/x-date-pickers/locales';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { ReactComponent as ArrowDown } from '~/shared/assets/arrowDown.svg';
import { ReactComponent as Calendar } from '~/shared/assets/CalendarSelect.svg';

const StyledDatePicker = styled(MuiDatePicker)<{ isinput: number }>`
  width: ${({ isinput }) => (isinput ? '154px' : '146px')};
  border-radius: 4px 4px 0 0px;
  margin: 8px;
  > label {
    top: 10px;
    left: 13px;
  }
  > div {
    padding: ${({ isinput }) => (isinput ? '0 0 5px 6px' : '3px 0px 1px 0px')};
  }
  > div:hover:before {
    border-bottom: 1px solid var(--date-picker-border) !important;
  }
  &:hover {
    background-color: var(--date-picker-hover);
    border: none !important;
  }
  button {
    padding: 8px;
    margin-bottom: 2px;
  }
  .MuiInputBase-input {
    font-family: Montserrat;
    color: #4c5e72;
    font-size: 16px;
    font-weight: 400;
    padding: 0 8px !important;
  }
  .MuiInputLabel-animated {
    display: none;
  }
  .MuiInputLabel-shrink {
    display: none;
  }
  .MuiIconButton-root {
    left: ${({ isinput }) => (isinput ? '-18px' : '-20px')};
    top: ${({ isinput }) => (isinput ? '1px' : '-1px')};
  }
  .MuiOutlinedInput-notchedOutline {
    z-index: -1;
    background-color: ${({ isinput }) => (isinput ? '#F7F8F9' : 'var(--date-picker-background)')};
    border: ${({ isinput }) => (isinput ? '1px solid #667686' : 'none')};
  }
  legend {
    display: none;
  }
`;

const dateCfg: any = {
  Calendar: {
    views: undefined,
    format: 'MMM DD YYYY',
  },
  'calendar-day': {
    views: undefined,
    format: 'MMM DD YYYY',
  },
  'calendar-month': {
    views: ['year', 'month'],
    format: 'MMM YYYY',
  },
  'calendar-year': {
    views: ['year'],
    format: 'YYYY',
  },
};

export default function DatePicker({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  name,
  value,
  onChange,
  type = 'Calendar',
  label,
  options,
  disabled,
  isInput,
  dateFilter,
}: {
  name: string;
  value: any;
  type?: string;
  label?: string;
  onChange: (date: string) => void;
  options?: any;
  disabled?: boolean;
  isInput?: boolean;
  dateFilter?: any;
}) {
  const minDateArr = options?.[1]?.id.split('/');
  const minDate = `${minDateArr?.[1]}.${minDateArr?.[2]}.${minDateArr?.[0]}`;
  const maxDateArr = options?.[2]?.id.split('/');
  const maxDate = `${maxDateArr?.[1]}.${maxDateArr?.[2]}.${maxDateArr?.[0]}`;
  const [yearDone, setYearDone] = useState(false);

  const [innerValue, setInnerValue] = useState(value);

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <StyledDatePicker
        isinput={isInput ? 1 : 0}
        views={dateCfg[type]?.views}
        format={dateCfg[type]?.format}
        maxDate={
          (dateFilter?.options[2].value && dayjs(dateFilter?.options[2].value)) || dayjs(maxDate) || dayjs(new Date())
        }
        minDate={
          (dateFilter?.options[1].value && dayjs(dateFilter?.options[1].value)) ||
          dayjs(minDate) ||
          dayjs(new Date('11.1.2021'))
        }
        label={label}
        value={innerValue}
        onYearChange={() => setYearDone(true)}
        onOpen={() => setYearDone(false)}
        slots={{ openPickerIcon: Calendar, switchViewIcon: ArrowDown }}
        className="datePicker"
        disabled={disabled}
        onChange={(date: any) => {
          if (!yearDone && type === 'calendar-month') return;
          setYearDone(false);
          onChange(
            dayjs(
              date && dayjs(new Date()).isBefore(date)
                ? dayjs(new Date()).subtract(1, 'months').endOf('month')
                : date &&
                    date?.isBefore(
                      (dateFilter?.options[1].value && dayjs(dateFilter?.options[1].value)) ||
                        dayjs(minDate || new Date('11.1.2021')),
                    )
                  ? dayjs(
                      (dateFilter?.options[1].value && dayjs(dateFilter?.options[1].value)) ||
                        minDate ||
                        new Date('11.1.2021'),
                    )
                  : date,
            ).format('YYYY-MM-DD'),
          );
        }}
      />
    </LocalizationProvider>
  );
}
